import { render, staticRenderFns } from "./dataDetails.vue?vue&type=template&id=e3ac6576&scoped=true&"
import script from "./dataDetails.vue?vue&type=script&lang=js&"
export * from "./dataDetails.vue?vue&type=script&lang=js&"
import style0 from "./dataDetails.vue?vue&type=style&index=0&id=e3ac6576&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ac6576",
  null
  
)

export default component.exports